import { render, staticRenderFns } from "./EventTypeIcon.vue?vue&type=template&id=fd824502&"
import script from "./EventTypeIcon.vue?vue&type=script&lang=js&"
export * from "./EventTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports